/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Doctor slug
 * @export
 * @interface DoctorSlug
 */
export interface DoctorSlug {
    /**
     * 
     * @type {string}
     * @memberof DoctorSlug
     */
    value?: string;
}

/**
 * Check if a given object implements the DoctorSlug interface.
 */
export function instanceOfDoctorSlug(value: object): value is DoctorSlug {
    return true;
}

export function DoctorSlugFromJSON(json: any): DoctorSlug {
    return DoctorSlugFromJSONTyped(json, false);
}

export function DoctorSlugFromJSONTyped(json: any, ignoreDiscriminator: boolean): DoctorSlug {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function DoctorSlugToJSON(json: any): DoctorSlug {
    return DoctorSlugToJSONTyped(json, false);
}

export function DoctorSlugToJSONTyped(value?: DoctorSlug | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
    };
}

